import { Outlet } from "react-router-dom";

const EndToEnd = () => <Outlet />;

export default EndToEnd;
